<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<ptl-dropdown align="end" [open]="open()" (openChange)="open.set($event)">
  <ptl-button
    trigger
    class="f_enrol-people-trigger"
    [type]="buttonType()"
    [size]="size()"
    [icon]="LucideUserPlus"
    [iconSuffix]="LucideChevronDown"
    [text]="labelKey() | transloco"
    [ariaExpanded]="open()"
    (clicked)="toggle()"
  ></ptl-button>

  <div class="enrol-menu" role="menu" [attr.aria-label]="labelKey() | transloco">
    <ptl-dropdown-item class="f_enrol-one-person" [menuItem]="true" (clicked)="openPersonDialog()">
      <span class="enrol-menu__item">
        <ptl-icon [icon]="LucideUserPlus" size="s" aria-hidden="true"></ptl-icon>
        <span class="enrol-menu__text">
          <span class="enrol-menu__title">{{ 'translations.adminEnrolment.menu.person' | transloco }}</span>
          <span class="enrol-menu__caption">{{ 'translations.adminEnrolment.menu.personCaption' | transloco }}</span>
        </span>
      </span>
    </ptl-dropdown-item>
    <ptl-dropdown-item class="f_enrol-csv" [menuItem]="true" (clicked)="openCsvDialog()">
      <span class="enrol-menu__item">
        <ptl-icon [icon]="LucideUpload" size="s" aria-hidden="true"></ptl-icon>
        <span class="enrol-menu__text">
          <span class="enrol-menu__title">{{ 'translations.adminEnrolment.menu.csv' | transloco }}</span>
          <span class="enrol-menu__caption">{{ 'translations.adminEnrolment.menu.csvCaption' | transloco }}</span>
        </span>
      </span>
    </ptl-dropdown-item>
  </div>
</ptl-dropdown>
